// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'
import { StateMessage } from '@teamnine/pcj-ui-v2'
import { WarningAmber } from '@/utils/material-icons'

const generateResult = (status: number) => {
  switch (status) {
    case 401:
      return {
        title: 'Sorry, this page doesn’t exist.',
        description:
          'Return to the previous page and try again. If this error persists, contact NextGen Support.',
      }
    case 503:
      return {
        title: 'Service Unavailable',
        description:
          'The server is temporarily unable to service your request. Please try again later.',
      }
    case 418:
      return {
        title: '418',
        description: "I'm a teapot.",
      }
    default:
      return {
        title: '404',
        description:
          "It looks like this page doesn't exist. Try looking elsewhere.",
      }
  }
}

export default function RootBoundary() {
  const error = useRouteError()

  if (isRouteErrorResponse(error)) {
    const { title, description } = generateResult(error.status)

    return (
      <StateMessage.Empty
        title={title}
        description={description}
        Icon={WarningAmber}
        mt={64}
      />
    )
  }

  const { title, description } = generateResult(404)

  return (
    <StateMessage.Empty
      title={title}
      description={description}
      Icon={WarningAmber}
      mt={64}
    />
  )
}
